import IconPlay from "../../svgs/icon_play.svg";
import styles from "@/styles/Video.module.scss";
export default function PlayerSurface({ active, onClick }) {
  if (!active) {
    return null;
  }

  return (
    <div className={styles.surface}>
      <span className={styles.button} onClick={onClick}>
        <IconPlay />
      </span>
    </div>
  );
}
